import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lic_admin',
  templateUrl: './lic_admin.component.html',
  styleUrls: ['./lic_admin.component.css']
})
export class Lic_adminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
